import request from '@/utils/request'

// 获取短信验证码
export function getSMSCode(phone) {
  return request({
    url: '/SMSCode?phoneNum=' + phone,
    method: 'get'
  })
}

// 校验验证码
export function checkSMSCode(params) {
  return request({
    url: '/checkSMSCode',
    method: 'get',
    params: params
  })
}

// 短信验证码登录
export function loginSMS(params) {
  return request({
    url: '/loginSMS',
    method: 'get',
    params: params
  })
}

//获取修改用户信息验证码
export const getEditPhoneCodeAPI = (params) => {
  return request({
    url: '/system/user/changePhoneNumber/getCode',
    method: 'get',
    params
  })
}

